import { useMemo } from 'react'
import useSWR from 'swr'
import type { Tag } from '@ludus/core'
import { listTags } from '@/lib/api/tags.ts'

const TAGS_KEY = ['tags'] as const

/**
 * Fetches the tenant-global tag registry. Tags are not pipeline-scoped, so
 * the SWR key is constant — all consumers share a single cache entry.
 *
 * Returns `tagsMap` for O(1) lookups by id (the format stored on leads.tags).
 */
export function useTags() {
  const { data, mutate } = useSWR(TAGS_KEY, () => listTags())
  const tags: Tag[] = data ?? []
  const tagsMap = useMemo(() => new Map(tags.map((t) => [t.id as string, t])), [tags])
  return { tags, tagsMap, mutateTags: mutate }
}
